import { useState, ReactNode } from 'react';
import { LoadingContext, loadingManager } from '@/contexts/loadingManager';

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);

    // manager에 연결
    loadingManager.start = () => setIsLoading(true);
    loadingManager.stop = () => setIsLoading(false);

    return (
        <LoadingContext.Provider
            value={{ isLoading, setLoading: setIsLoading }}
        >
            {children}
        </LoadingContext.Provider>
    );
};
